<div>
  <div class="d-flex align-items-center justify-content-space-between gap-16">
    <p class="p1">
      {{ 'Free entries: ' | trans:'cards/card-details-modal/actions/free-entries.Label' }}
    </p>

    <button
      class="button button--md button--primary-ghost text-uppercase p2 fw-semibold"
      (click)="addFreeEntryModalComponent.open()"
    >
      <i class="ri-add-line"></i>
      {{ 'Add Free entry' | trans:'cards/card-details-modal/actions/free-entries/add-free-entry-button.Label' }}
    </button>
  </div>

  <div class="m-t-24">
    @if (card.freeEntryItems.length > 0) {
      <app-switch
        text="{{ 'Show used' | trans:'cards/card-details-modal/actions/free-entries/showUsed.Text' }}"
        [(ngModel)]="showUsedItems"
      />

      <div class="m-t-16">
        @if ((card.freeEntryItems | arrayFilter:(showUsedItems ? excludeUnusuedItems : excludeUsedItems)).length > 0) {
          <table class="base full-width">
            <thead>
              <tr>
              <th>
                {{ 'Issuer' | trans:'cards/card-details-modal/actions/free-entries/issuer.Label' }}
              </th>
              <th>
                {{ 'Valid from' | trans:'cards/card-details-modal/actions/free-entries/validFrom.Label' }}
              </th>
              <th>
                {{ 'Valid until' | trans:'cards/card-details-modal/actions/free-entries/validUntil.Label' }}
              </th>
              <th>
                {{ 'Date used' | trans:'cards/card-details-modal/actions/free-entries/dateUsed.Label' }}
              </th>
              <th></th>
            </tr>
            </thead>
            <tbody>
              @for (f of ((card.freeEntryItems | arrayFilter:(showUsedItems ? excludeUnusuedItems : excludeUsedItems)) | arraySortByKey:(showUsedItems ? 'dateUsed' : 'publisherName'):(showUsedItems ? 'desc' : 'asc')); track f.freeEntryId) {
                <tr>
                  <td>
                    <div
                      class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                    >
                      @if (f.publisherName) {
                        <span class="t4 text-uppercase fw-medium c-t-blue-700">
                      {{ f.publisherName }}
                    </span>
                      } @else {
                        {{ f.publisherName | empty }}
                      }
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ (f.validFrom | localeDateFormat) | empty }}
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ (f.validUntil | localeDateFormat) | empty }}
                    </div>
                  </td>
                  <td>
                    <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                      {{ (f.dateUsed | localeDatetimeFormat) | empty }}
                    </div>
                  </td>
                  <td>
                    <div class="d-flex align-items-center justify-content-flex-end">
                      @if (!f.dateUsed) {
                        <button
                          class="button button--icon-sm button--no-border c-t-nok-400"
                          appConfirmation
                          confirmationModalTitle="{{ 'Delete free entry' | trans:'cards/card-details-modal/actions/free-entries/delete-free-entry-confirmation-modal.Title' }}"
                          confirmationModalText="{{ 'Are you sure you want to delete this free entry?' | trans:'cards/card-details-modal/actions/free-entries/delete-free-entry-confirmation-modal.Text' }}"
                          (click)="$event.stopPropagation()"
                          (onConfirm)="deleteFreeEntryFromCard(f.freeEntryId)"
                          [disabled]="f.dateUsed"
                          appTooltip
                          content="{{ 'Delete free entry' | trans:'cards/card-details-modal/actions/free-entries/delete-free-entry-confirmation-modal.Tooltip' }}"
                        >
                          <i class="ri-close-circle-line"></i>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        } @else {
          <p class="text-center">
            {{ 'No data found' | trans:'app/tables/no-data-found.Label' }}
          </p>
        }
      </div>
    } @else {
      <p class="text-center">
        {{ 'No data found' | trans:'app/tables/no-data-found.Label' }}
      </p>
    }
  </div>
</div>

<app-add-free-entry-modal
  #addFreeEntryModalComponent
  [card]="card"
  (formFinished)="cardUpdated.emit($event)"
/>
